import type { EncounterWorkNote } from '../types/encounterWork';

/**
 * A note the client shows before the server has taken it: the cache entry the
 * add-note mutation writes optimistically, and the marker the card reads to
 * draw it dimmed until the server's own note takes its place.
 *
 * The marker is the id. Server ids are UUIDs; a provisional id carries this
 * prefix and never leaves the client.
 */
const PROVISIONAL_ID_PREFIX = 'provisional:';

export interface ProvisionalNoteArgs {
  body: string;
  /** The signed-in person's display name, or null before the user read lands. */
  authorName: string | null;
  claimId: string | null;
  now?: () => Date;
}

export function makeProvisionalNote({
  body,
  authorName,
  claimId,
  now = () => new Date(),
}: ProvisionalNoteArgs): EncounterWorkNote {
  const at = now();
  return {
    id: `${PROVISIONAL_ID_PREFIX}${at.getTime()}-${Math.random().toString(36).slice(2, 8)}`,
    body,
    author_name: authorName,
    claim_id: claimId,
    created_at: at.toISOString(),
  };
}

export const isProvisionalNote = (note: Pick<EncounterWorkNote, 'id'>): boolean =>
  note.id.startsWith(PROVISIONAL_ID_PREFIX);
